import { List } from '@shared/models/interfaces/List.interface';
import { SegmentObject } from '@shared/models/interfaces/object.interface';
export class SetObjects {
  static readonly type = '[OBJECT] Set Objects';
  constructor(public objects: List<SegmentObject>) {}
}
